// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --dark-primary-color: #3498db;
    --dark-secondary-color: #2ecc71;
    --dark-background-color: #ecf0f1;
    --dark-text-color: #2c3e50;
    /* Add more variables as needed */
  }
.page-wrapper .page-body-wrapper .page-sidebar {
    background: #fff;
    height: 100vh;
    position: fixed;
    top: 0;
    transition: .3s;
    width: 255px;
    z-index: 9;
}
.page-wrapper .page-body-wrapper .page-sidebar .sidebar-user img {
    box-shadow: 0 0 15px #4466f24d;
    padding-top: 12px;
    padding:10%;
    width: 100%;
}
.page-main-header .main-header-right {
    align-items: center;
    display: flex;
    justify-content: space-between;
    height: 100%;
    margin: 0;
    padding: 0 40px;
    width: 100%;
}

.page-wrapper .page-main-header {
    align-items: center;
    background-color: #fff;
    box-shadow: 0 0 10px 1px #4466f20d;
    display: flex;
    height: 80px;
    margin-left: 255px;
    position: fixed;
    top: 0;
    transition: .3s;
    width: calc(100% - 255px);
    z-index: 10;
}

@media (min-width: 992px) {
    .d-lg-none {
        display: none !important;
    }
}
.switch-sm .switch {
    height: 16px;
    margin-bottom: 0;
    margin-top: 10px;
    width: 25px;
}
.page-main-header .main-header-right svg{
    color: black;
}
.page-main-header .main-header-right .nav-right {
    padding-left: 0;
    text-align: right;
}
.page-main-header .main-header-right .nav-right>ul {
    align-items: center;
    display: flex;
    justify-content: flex-end;
}
.pull-right {
    float: right;
}
.page-main-header .main-header-right .nav-right {
    padding-left: 0;
    text-align: right;
}
.col-auto {
    flex: 0 0 auto;
    width: auto;
}
.nav-menus {
    display: none !important;
}
.page-wrapper .page-main-header.open {
    margin-left: 0;
    transition: .3s;
    width: 100%;
}
.page-wrapper .page-body-wrapper .page-sidebar.open {
    display: block;
    margin-left: -260px;
}
@media only screen and (max-width: 991px) {
    .page-wrapper .page-body-wrapper .page-sidebar~.page-body {
        margin-left: 0;
        margin-top: 60px;
    }
    .page-wrapper .page-main-header {
        height: 60px;
        margin-left: 0;
        width: 100%;
        z-index: 11;
    }
}
@media only screen and (max-width: 575px) {
    .page-wrapper .page-main-header .main-header-right {
        padding: 0 15px;
    }
}

.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu {
    list-style: none;
    margin: 0;
    padding: 20px;
}

.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu li {
    width: 100%;
}
.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-header {
    color: #313131;
    font-size: 14px;
    font-weight: 600;
    display: flex;
    letter-spacing: .5px;
    align-items: center;
    padding-bottom: 12px;
    padding-top: 12px;
    text-transform: capitalize;
}

.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu>li>a {
    display: block;
    transition: .3s;
}

.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-header svg {
    stroke-width: 3px;
    height: 14px;
    margin-right: 14px;
    vertical-align: text-bottom;
    width: 14px;
}
.page-wrapper .page-body-wrapper .sidebar {
    box-shadow: 0 0 11px #8fa4e814;
    height: calc(100vh - 80px);
    overflow: auto;
}
.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu>li>a:hover {
    color: #ff8084;
    padding-left: 3px;
    transition: .3s;
}

.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu>li.active>a, .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu>li:hover>a {
    border-left-color: #2a3142;
    color: #313131;
    transition: .3s;
}

.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu>li>a {
    display: block;
    transition: .3s;
}
.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu a {
    text-decoration: none;
}

@media only screen and (max-width: 991px) {
    .page-wrapper .page-body-wrapper .page-sidebar {
        height: calc(100vh - 60px) !important;
        top: 60px !important;
    }
}
@media only screen and (max-width: 575px) {
    .page-wrapper .page-main-header .main-header-right {
        padding: 0 15px;
    }
}
@media only screen and (max-width: 991px) {
    .page-wrapper .page-main-header {
        height: 60px;
        margin-left: 0;
        width: 100%;
        z-index: 11;
    }
}

.page-wrapper .page-body-wrapper .page-sidebar~.page-body {
    margin-left: 255px;
    transition: .3s;
}
.page-wrapper .page-body-wrapper .page-body {
    background-color: #f8f8f9;
    margin-top: 80px;
    min-height: calc(100vh - 80px);
    padding: 0 15px;
    position: relative;
}

.page-wrapper .page-body-wrapper .page-sidebar.open~.page-body {
    margin-left: 0;
    transition: .3s;
}
@media only screen and (max-width: 991px) {
    .page-wrapper .page-main-header .main-header-right .nav-right {
        padding: 0;
        position: static;
    }
}

.page-wrapper .page-body-wrapper .page-header .row .h3, .page-wrapper .page-body-wrapper .page-header .row h3 {
    font-family: Nunito;
    font-size: 22px;
    font-weight: 800;
    margin-bottom: 0;
    text-transform: uppercase;
    color:black
}

.page-wrapper .page-body-wrapper .page-header {
    padding-bottom: 30px;
    padding-top: 30px;
}
.card .card-body {
    background-color: #0000;
    padding: 30px;
}
.product-physical{
    border: 1px solid #0000001a;
}
.product-physical .rdt_Table .rdt_TableHead{
    box-shadow: 0 2px 15px 0 #00000026;
    z-index: 1;
}
.product-physical .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol{
    border-right: 1px solid #0000000d;
    flex: 100 0 auto;
    padding: 5px;
    width: 100px;
}
.product-physical .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol .rdt_TableCol_Sortable{
/* background-color: #f8f8f9; */
justify-content: center;
padding: 5px;
    /* color: #313131; */
    font-size: 14px;
}
.product-physical .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell{
    /* background-color: #fff;
    border-right: 1px solid #0000000d;
    font-size: 14px; */
    justify-content: center;
}
.page-wrapper .page-body-wrapper .page-sidebar .open{
    width: 75px;
}
.chat-box{
    height: 100%;
    background-color: white;
    border:1px solid gray;
    border-radius: 5px;
}
.remove-pad{
    padding: 0px !important;
    margin:0px !important;
}
.full-height{
    height: calc(100vh - 80px);
    overflow: auto;
}
.background-div{
    background-color:white;
}
.chat-message-box{
    height: 500px;
    overflow-y: auto;
    border: 1px solid #ccc;
    background:#f9f9f9 ;
    border-radius: 5px;
    padding:10px
    /* style={{ height: "500px", overflowY: "auto", border: "1px solid #ccc", padding: "10px", background: "#f9f9f9", borderRadius: "5px" }} */
}
.form-label{
    color:black
}
.sidebar-user{
    background-color: gray;
}
/*Dark theme code */
.dark .page-wrapper .page-body-wrapper .page-sidebar{
    background-color: black;
}
.dark .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-header{
    color:white
}
.dark .page-wrapper .page-body-wrapper .page-sidebar span{
    color:white
}
.dark .page-wrapper .page-main-header {
background-color: black;
}
.dark .page-main-header .main-header-right svg{
    color:white;
}
.dark .document-uploader{
    background-color: #0c363c;
    color:white;
}
.dark .background-div{
    background-color:#1f2326
}
.dark .page-wrapper .page-body-wrapper .page-body{
    background-color:#1f2326 ;
}
.dark .document-uploader {
    & .file-item {
        & .file-info {
            p {
                color: white;
            }}}
        }
.dark .bg-set{
    background-color: #1f2326;
}
.dark .chat-message-box{
    background-color: #0c363c;
}
.dark .form-control{
    background-color: #0c363c;
    color:white;
}
.dark .form-control::placeholder{
    color:rgba(255, 255, 255, 0.559);
}
.dark .page-wrapper  .page-header .row h3 {
    color:white;
}
.dark .form-label{
    color:white
}
.dark h5{
    color:white;
}
.dark .sidebar-user{
    background-color: black;
}`, "",{"version":3,"sources":["webpack://./src/styles/custom.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;IAC7B,+BAA+B;IAC/B,gCAAgC;IAChC,0BAA0B;IAC1B,iCAAiC;EACnC;AACF;IACI,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,MAAM;IACN,eAAe;IACf,YAAY;IACZ,UAAU;AACd;AACA;IACI,8BAA8B;IAC9B,iBAAiB;IACjB,WAAW;IACX,WAAW;AACf;AACA;IACI,mBAAmB;IACnB,aAAa;IACb,8BAA8B;IAC9B,YAAY;IACZ,SAAS;IACT,eAAe;IACf,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,kCAAkC;IAClC,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,MAAM;IACN,eAAe;IACf,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI;QACI,wBAAwB;IAC5B;AACJ;AACA;IACI,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,YAAY;AAChB;AACA;IACI,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,mBAAmB;IACnB,aAAa;IACb,yBAAyB;AAC7B;AACA;IACI,YAAY;AAChB;AACA;IACI,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,cAAc;IACd,WAAW;AACf;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,cAAc;IACd,eAAe;IACf,WAAW;AACf;AACA;IACI,cAAc;IACd,mBAAmB;AACvB;AACA;IACI;QACI,cAAc;QACd,gBAAgB;IACpB;IAGA;QACI,YAAY;QACZ,cAAc;QACd,WAAW;QACX,WAAW;IACf;AAPJ;AASA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;AACA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,oBAAoB;IACpB,mBAAmB;IACnB,oBAAoB;IACpB,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,2BAA2B;IAC3B,WAAW;AACf;AACA;IACI,8BAA8B;IAC9B,0BAA0B;IAC1B,cAAc;AAClB;AACA;IACI,cAAc;IACd,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,0BAA0B;IAC1B,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;AACA;IACI,qBAAqB;AACzB;;AAEA;IACI;QACI,qCAAqC;QACrC,oBAAoB;IACxB;AACJ;AACA;IACI;QACI,eAAe;IACnB;AACJ;AACA;IACI;QACI,YAAY;QACZ,cAAc;QACd,WAAW;QACX,WAAW;IACf;AACJ;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,8BAA8B;IAC9B,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;AACA;IACI;QACI,UAAU;QACV,gBAAgB;IACpB;AACJ;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;IACzB;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;AACrB;AACA;IACI,uBAAuB;IACvB,aAAa;AACjB;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,kCAAkC;IAClC,UAAU;AACd;AACA;IACI,iCAAiC;IACjC,gBAAgB;IAChB,YAAY;IACZ,YAAY;AAChB;AACA;AACA,+BAA+B;AAC/B,uBAAuB;AACvB,YAAY;IAGR,oBAAoB;IACpB,eAAe;AAHnB;AAKA;IACI;;sBAEkB;IAClB,uBAAuB;AAC3B;AACA;IACI,WAAW;AACf;AACA;IACI,YAAY;IACZ,uBAAuB;IACvB,qBAAqB;IACrB,kBAAkB;AACtB;AACA;IACI,uBAAuB;IACvB,qBAAqB;AACzB;AACA;IACI,0BAA0B;IAC1B,cAAc;AAClB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,0IAA0I;AAC9I;AACA;IACI;AACJ;AACA;IACI,sBAAsB;AAC1B;AACA,mBAAmB;AACnB;IACI,uBAAuB;AAC3B;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;AACA,uBAAuB;AACvB;AACA;IACI,WAAW;AACf;AACA;IACI,yBAAyB;IACzB,WAAW;AACf;AACA;IACI;AACJ;AACA;IACI,yBAAyB;AAC7B;AACA;IACI;QACI;YACI;gBACI,YAAY;YAChB,CAAC,CAAC;QACN;AACR;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;IACzB,WAAW;AACf;AACA;IACI,gCAAgC;AACpC;AACA;IACI,WAAW;AACf;AACA;IACI;AACJ;AACA;IACI,WAAW;AACf;AACA;IACI,uBAAuB;AAC3B","sourcesContent":[":root {\n    --dark-primary-color: #3498db;\n    --dark-secondary-color: #2ecc71;\n    --dark-background-color: #ecf0f1;\n    --dark-text-color: #2c3e50;\n    /* Add more variables as needed */\n  }\n.page-wrapper .page-body-wrapper .page-sidebar {\n    background: #fff;\n    height: 100vh;\n    position: fixed;\n    top: 0;\n    transition: .3s;\n    width: 255px;\n    z-index: 9;\n}\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-user img {\n    box-shadow: 0 0 15px #4466f24d;\n    padding-top: 12px;\n    padding:10%;\n    width: 100%;\n}\n.page-main-header .main-header-right {\n    align-items: center;\n    display: flex;\n    justify-content: space-between;\n    height: 100%;\n    margin: 0;\n    padding: 0 40px;\n    width: 100%;\n}\n\n.page-wrapper .page-main-header {\n    align-items: center;\n    background-color: #fff;\n    box-shadow: 0 0 10px 1px #4466f20d;\n    display: flex;\n    height: 80px;\n    margin-left: 255px;\n    position: fixed;\n    top: 0;\n    transition: .3s;\n    width: calc(100% - 255px);\n    z-index: 10;\n}\n\n@media (min-width: 992px) {\n    .d-lg-none {\n        display: none !important;\n    }\n}\n.switch-sm .switch {\n    height: 16px;\n    margin-bottom: 0;\n    margin-top: 10px;\n    width: 25px;\n}\n.page-main-header .main-header-right svg{\n    color: black;\n}\n.page-main-header .main-header-right .nav-right {\n    padding-left: 0;\n    text-align: right;\n}\n.page-main-header .main-header-right .nav-right>ul {\n    align-items: center;\n    display: flex;\n    justify-content: flex-end;\n}\n.pull-right {\n    float: right;\n}\n.page-main-header .main-header-right .nav-right {\n    padding-left: 0;\n    text-align: right;\n}\n.col-auto {\n    flex: 0 0 auto;\n    width: auto;\n}\n.nav-menus {\n    display: none !important;\n}\n.page-wrapper .page-main-header.open {\n    margin-left: 0;\n    transition: .3s;\n    width: 100%;\n}\n.page-wrapper .page-body-wrapper .page-sidebar.open {\n    display: block;\n    margin-left: -260px;\n}\n@media only screen and (max-width: 991px) {\n    .page-wrapper .page-body-wrapper .page-sidebar~.page-body {\n        margin-left: 0;\n        margin-top: 60px;\n    }\n}\n@media only screen and (max-width: 991px) {\n    .page-wrapper .page-main-header {\n        height: 60px;\n        margin-left: 0;\n        width: 100%;\n        z-index: 11;\n    }\n}\n@media only screen and (max-width: 575px) {\n    .page-wrapper .page-main-header .main-header-right {\n        padding: 0 15px;\n    }\n}\n\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu {\n    list-style: none;\n    margin: 0;\n    padding: 20px;\n}\n\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu li {\n    width: 100%;\n}\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-header {\n    color: #313131;\n    font-size: 14px;\n    font-weight: 600;\n    display: flex;\n    letter-spacing: .5px;\n    align-items: center;\n    padding-bottom: 12px;\n    padding-top: 12px;\n    text-transform: capitalize;\n}\n\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu>li>a {\n    display: block;\n    transition: .3s;\n}\n\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-header svg {\n    stroke-width: 3px;\n    height: 14px;\n    margin-right: 14px;\n    vertical-align: text-bottom;\n    width: 14px;\n}\n.page-wrapper .page-body-wrapper .sidebar {\n    box-shadow: 0 0 11px #8fa4e814;\n    height: calc(100vh - 80px);\n    overflow: auto;\n}\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu>li>a:hover {\n    color: #ff8084;\n    padding-left: 3px;\n    transition: .3s;\n}\n\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu>li.active>a, .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu>li:hover>a {\n    border-left-color: #2a3142;\n    color: #313131;\n    transition: .3s;\n}\n\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu>li>a {\n    display: block;\n    transition: .3s;\n}\n.page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu a {\n    text-decoration: none;\n}\n\n@media only screen and (max-width: 991px) {\n    .page-wrapper .page-body-wrapper .page-sidebar {\n        height: calc(100vh - 60px) !important;\n        top: 60px !important;\n    }\n}\n@media only screen and (max-width: 575px) {\n    .page-wrapper .page-main-header .main-header-right {\n        padding: 0 15px;\n    }\n}\n@media only screen and (max-width: 991px) {\n    .page-wrapper .page-main-header {\n        height: 60px;\n        margin-left: 0;\n        width: 100%;\n        z-index: 11;\n    }\n}\n\n.page-wrapper .page-body-wrapper .page-sidebar~.page-body {\n    margin-left: 255px;\n    transition: .3s;\n}\n.page-wrapper .page-body-wrapper .page-body {\n    background-color: #f8f8f9;\n    margin-top: 80px;\n    min-height: calc(100vh - 80px);\n    padding: 0 15px;\n    position: relative;\n}\n\n.page-wrapper .page-body-wrapper .page-sidebar.open~.page-body {\n    margin-left: 0;\n    transition: .3s;\n}\n@media only screen and (max-width: 991px) {\n    .page-wrapper .page-main-header .main-header-right .nav-right {\n        padding: 0;\n        position: static;\n    }\n}\n\n.page-wrapper .page-body-wrapper .page-header .row .h3, .page-wrapper .page-body-wrapper .page-header .row h3 {\n    font-family: Nunito;\n    font-size: 22px;\n    font-weight: 800;\n    margin-bottom: 0;\n    text-transform: uppercase;\n    color:black\n}\n\n.page-wrapper .page-body-wrapper .page-header {\n    padding-bottom: 30px;\n    padding-top: 30px;\n}\n.card .card-body {\n    background-color: #0000;\n    padding: 30px;\n}\n.product-physical{\n    border: 1px solid #0000001a;\n}\n.product-physical .rdt_Table .rdt_TableHead{\n    box-shadow: 0 2px 15px 0 #00000026;\n    z-index: 1;\n}\n.product-physical .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol{\n    border-right: 1px solid #0000000d;\n    flex: 100 0 auto;\n    padding: 5px;\n    width: 100px;\n}\n.product-physical .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol .rdt_TableCol_Sortable{\n/* background-color: #f8f8f9; */\njustify-content: center;\npadding: 5px;\n}\n.product-physical .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol .rdt_TableCol_Sortable{\n    /* color: #313131; */\n    font-size: 14px;\n}\n.product-physical .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell{\n    /* background-color: #fff;\n    border-right: 1px solid #0000000d;\n    font-size: 14px; */\n    justify-content: center;\n}\n.page-wrapper .page-body-wrapper .page-sidebar .open{\n    width: 75px;\n}\n.chat-box{\n    height: 100%;\n    background-color: white;\n    border:1px solid gray;\n    border-radius: 5px;\n}\n.remove-pad{\n    padding: 0px !important;\n    margin:0px !important;\n}\n.full-height{\n    height: calc(100vh - 80px);\n    overflow: auto;\n}\n.background-div{\n    background-color:white;\n}\n.chat-message-box{\n    height: 500px;\n    overflow-y: auto;\n    border: 1px solid #ccc;\n    background:#f9f9f9 ;\n    border-radius: 5px;\n    padding:10px\n    /* style={{ height: \"500px\", overflowY: \"auto\", border: \"1px solid #ccc\", padding: \"10px\", background: \"#f9f9f9\", borderRadius: \"5px\" }} */\n}\n.form-label{\n    color:black\n}\n.sidebar-user{\n    background-color: gray;\n}\n/*Dark theme code */\n.dark .page-wrapper .page-body-wrapper .page-sidebar{\n    background-color: black;\n}\n.dark .page-wrapper .page-body-wrapper .page-sidebar .sidebar-menu .sidebar-header{\n    color:white\n}\n.dark .page-wrapper .page-body-wrapper .page-sidebar span{\n    color:white\n}\n.dark .page-wrapper .page-main-header {\nbackground-color: black;\n}\n.dark .page-main-header .main-header-right svg{\n    color:white;\n}\n.dark .document-uploader{\n    background-color: #0c363c;\n    color:white;\n}\n.dark .background-div{\n    background-color:#1f2326\n}\n.dark .page-wrapper .page-body-wrapper .page-body{\n    background-color:#1f2326 ;\n}\n.dark .document-uploader {\n    & .file-item {\n        & .file-info {\n            p {\n                color: white;\n            }}}\n        }\n.dark .bg-set{\n    background-color: #1f2326;\n}\n.dark .chat-message-box{\n    background-color: #0c363c;\n}\n.dark .form-control{\n    background-color: #0c363c;\n    color:white;\n}\n.dark .form-control::placeholder{\n    color:rgba(255, 255, 255, 0.559);\n}\n.dark .page-wrapper  .page-header .row h3 {\n    color:white;\n}\n.dark .form-label{\n    color:white\n}\n.dark h5{\n    color:white;\n}\n.dark .sidebar-user{\n    background-color: black;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
